var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDetailViewIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 17H20C20.003 17 20 7.006 20 7.006C20 7 14 7 14 7V17ZM12 5H20C21.105 5 22 5.897 22 7.006V16.994C22.0011 17.2572 21.9501 17.5181 21.85 17.7615C21.75 18.005 21.6028 18.2263 21.4169 18.4127C21.2311 18.5991 21.0102 18.7469 20.7671 18.8477C20.5239 18.9485 20.2632 19.0003 20 19H12V5ZM2.00001 7H10V5H2.99701C2.86579 4.99987 2.73584 5.02566 2.61462 5.07591C2.4934 5.12615 2.38331 5.19986 2.29066 5.29278C2.19802 5.3857 2.12465 5.49602 2.07477 5.61739C2.02489 5.73876 1.99948 5.86878 2.00001 6V7ZM2.00001 11H10V9H2.00001V11ZM2.00001 18C2.00001 18.552 2.45301 19 2.99701 19H10V17H2.00001V18ZM2.00001 15H10V13H2.00001V15Z",
    fill: "#7D7D82"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDetailViewIcon);
export default __webpack_public_path__ + "static/media/DetailViewIcon.16f8f842024319aac6677a85c58fe59a.svg";
export { ForwardRef as ReactComponent };